export const login = {
  join_button: 'Join Now',
  join_subtitle: 'An Affordable, Reliable Health Care Alternative',
  join_title: 'Join Medi-Share',
  login: 'Login',
  login_subtitle: 'Login to view and manage your account',
  login_title: 'PrayerStream Login',
  privacy_disclaimer_text: 'Our secure member login protects your private information, while allowing you to access important information about your Medi-Share membership. View our <privacyLink>Privacy Policy</privacyLink>.',
  register_link: 'Register now',
  registered_text: 'Not registered for Member Center?',
} as const;

export type LoginNamespace = Record<keyof typeof login, string>;
